import { gql } from '@apollo/client';
import { CORE_INTERVIEW_SECTION_FIELDS } from './interviewSection.fragment';

export const CORE_POSITION_FIELDS = gql`
  ${CORE_INTERVIEW_SECTION_FIELDS}
  fragment CorePositionFields on Position {
    _id
    title
    archived
    defaultQuestions {
      sectionId
      section {
        ...CoreInterviewSectionFields
      }
      questions
    }
    createdAt
    updatedAt
  }
`;

export default CORE_POSITION_FIELDS;
